import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { rem } from '@mantine/core';
import styled, { css } from 'styled-components';

interface IContentObject {
	[key: string]: string | number | React.ReactNode;
}
export interface Props {
	title?: string;
	subtitle?: string[] | IContentObject[];
	button?: React.ReactNode;
	onClick?: () => void;
	selected?: boolean;
}

export const BottomContent = ({ title, subtitle, button, onClick, selected }: Props) => {
	return (
		<ContentContainer>
			<BlockContentContainer selected={selected}>
				{title && (
					<ContentSelected>
						<Text variant="sans/11/400" disableVariantMapping>
							{title}
						</Text>
					</ContentSelected>
				)}
				{subtitle && (
					<ContentSubtitleContainer>
						{subtitle.map((subtitleLine, index) =>
							typeof subtitleLine === 'string' ? (
								<ContentSelected key={`${subtitleLine + index}`}>
									<Text variant="sans/14/600" disableVariantMapping>
										{subtitleLine}
									</Text>
								</ContentSelected>
							) : (
								<ContentSelected key={`${subtitleLine.key}-${index}`}>
									<KeyText
										capitalizeFirst
										variant="sans/14/200"
										disableVariantMapping
									>
										{subtitleLine.key}
									</KeyText>
									<Text
										variant="sans/14/600"
										disableVariantMapping
										className={subtitleLine.key ? 'add-padding' : ''}
									>
										{subtitleLine.value}
									</Text>
								</ContentSelected>
							)
						)}
					</ContentSubtitleContainer>
				)}
			</BlockContentContainer>
			{button && <ButtonContainer onClick={onClick}>{button}</ButtonContainer>}
		</ContentContainer>
	);
};

const ContentContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
`;
export const BlockContentContainer = styled.div<{ selected?: boolean }>`
	display: flex;
	flex-direction: column;
	${({ selected }) => {
		return selected
			? css`
					color: ${({ theme }) => theme.v2.color.neutral[300]};
				`
			: css`
					color: ${({ theme }) => theme.v2.color.neutral[600]};
				`;
	}}
`;

const ButtonContainer = styled.div`
	align-self: flex-end;
`;
export const ContentSelected = styled.div`
	padding-right: ${rem(4)};

	:not(:first-child) {
		padding-left: ${rem(4)};
	}

	:last-child {
		padding-right: ${rem(12)};
	}

	.add-padding {
		padding-left: ${rem(4)};
	}
`;

export const ContentSubtitleContainer = styled.div`
	display: flex;
	${ContentSelected} {
		:not(:last-child) {
			border-right: 1px solid ${({ theme }) => theme.v2.color.neutral[900]};
		}
	}
`;

const KeyText = styled(Text)`
	color: ${({ theme }) => theme.v2.color.neutral[300]};
`;
